import { render, staticRenderFns } from "./CareCheckingPrescriptions.vue?vue&type=template&id=52851d7c&scoped=true&"
import script from "./CareCheckingPrescriptions.vue?vue&type=script&lang=js&"
export * from "./CareCheckingPrescriptions.vue?vue&type=script&lang=js&"
import style0 from "./CareCheckingPrescriptions.vue?vue&type=style&index=0&id=52851d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52851d7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
